export { BRAND_NAME as VIDEO_BRAND_NAME } from './brand';
export const VIDEO_WEBSITE = 'overlandtraces.com';
